import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import Accordion from '../../components/Display/Accordion'
import Empty from '../../components/Display/Empty'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import { TextArea } from '../../components/Inputs/TextArea'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import { fetchBanks } from '../../redux/actions/banks'
import { fetchDealers } from '../../redux/actions/dealers'
import { RootState } from '../../redux/store'
import { emailRegex } from '../../utils/validations'
import { accountDelete, accountSelector } from './accountsFetching'
import EmptyAccoutnAnimation from '../../assets/animations/card-rejected.json'
import axios from 'axios'

const docs = [
  {
    value: 'V',
    text: 'V',
  },
  {
    value: 'J',
    text: 'J',
  },
  {
    value: 'E',
    text: 'E',
  },
  {
    value: 'P',
    text: 'P',
  },
  {
    value: 'G',
    text: 'G',
  },
  {
    value: 'C',
    text: 'C',
  },
]

const countries = [
  {
    value: 1,
    text: '+58',
  },
  {
    value: 2,
    text: '+1',
  },
]

export const Accounts: React.FC<any> = ({
  dealer,
  setModal,
  onCancel,
  setSelected,
}) => {
  const [accountTab, setAccountTab] = useState(0)

  return (
    <div className="m-auto">
      <div className="flex flex-nowrap rounded-lg bg-gray-100 divide-x-2 divide-gray-200 dark:bg-gray-800 m-auto mb-10">
        {/* <div className={`h-full flex items-center mb-5`}> */}
        {/* <Button onClick={() => setAccountTab(0)} style={{ marginRight: 15 }}>
          {' '}
          Cuentas{' '}
        </Button>
        <Button onClick={() => setAccountTab(1)}> Agregar Cuenta </Button> */}

        <div
          className={`px-3 flex-grow transition-all py-2.5 flex items-center justify-center cursor-pointer ${
            accountTab === 0 ? 'bg-white dark:bg-gray-600' : 'dark:bg-gray-900'
          }`}
          onClick={() => setAccountTab(0)}
        >
          <div className={`h-full flex items-center`}>
            <span className="text-center">
              {/* <Icon
                  className={`${
                    i === selected
                      ? 'text-primary dark:text-white'
                      : 'text-trueGray-600 dark:text-gray-300'
                  } mr-3 z-20 text-lg`}
                /> */}
            </span>
            <p
              className={`${
                accountTab === 0
                  ? 'text-primary dark:text-white'
                  : 'text-trueGray-600 dark:text-gray-300'
              }`}
            >
              <b>Cuentas</b>
            </p>
          </div>
        </div>

        <div
          className={`px-3 flex-grow transition-all py-2.5 flex items-center justify-center cursor-pointer ${
            accountTab === 1 ? 'bg-white dark:bg-gray-600' : 'dark:bg-gray-900'
          }`}
          onClick={() => setAccountTab(1)}
        >
          <div className={`h-full flex items-center`}>
            <span className="text-center">
              {/* <Icon
                  className={`${
                    i === selected
                      ? 'text-primary dark:text-white'
                      : 'text-trueGray-600 dark:text-gray-300'
                  } mr-3 z-20 text-lg`}
                /> */}
            </span>
            <p
              className={`${
                accountTab === 1
                  ? 'text-primary dark:text-white'
                  : 'text-trueGray-600 dark:text-gray-300'
              }`}
            >
              <b>Agregar Cuenta</b>
            </p>
          </div>
        </div>
      </div>
      {accountTab === 0 ? (
        <ViewAccounts
          dealer={dealer}
          setModal={setModal}
          setSelected={setSelected}
        />
      ) : (
        <AddAccounts
          dealer={dealer}
          setModal={setModal}
          onCancel={onCancel}
          setSelected={setSelected}
        />
      )}
    </div>
  )
}

export const nationalAccountMap = (data) =>
  data.map((account) => ({
    Nombre: account.name,
    Tipo: account.document.documentType,
    Documento: account.document.document,
    Email: account.email,
    Banco: account.bank,
    'Tipo de cuenta': account.typeAccount,
    'Número de cuenta': account.accountNumber,
  }))

export const instantPaymentAccountMap = (data) =>
  data.map((account) => ({
    Nombre: account.name,
    Tipo: account.document.documentType,
    Documento: account.document.document,
    Teléfono: account.phone,
    Banco: account.bank,
  }))

export const otherPaymentMap = (data) =>
  data.map((account) => ({
    Nombre: account.name,
    'Método de pago': account.paymentMethod,
    Descripción: account.description,
  }))

// const server = process.env.REACT_APP_SERVER_URL

export const ViewAccounts: React.FC<any> = ({
  dealer,
  setModal,
  setSelected,
  enableDelete = true,
  addToBillsToPay,
}) => {
  const [userConfig] = useLocalStorageState('user-config')
  const { addAlert } = useSnackBars()
  const dispatch = useDispatch()

  const handleInstantPaymentAccDelete = async (dataIndex) => {
    try {
      const res = await accountDelete(
        `${accountSelector('instantPayment')}/${dataIndex}`
      )
      addAlert({ message: 'Eliminando cuenta...', status: 'loading' })
      if (res) {
        addAlert({ message: 'Cuenta eliminada.', status: 'success' })
        dispatch(
          fetchDealers(
            [''],
            [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
          )
        )
        setModal(false)
      }
    } catch (error) {
      addAlert({ message: 'Error', status: 'error' })
    }
    setSelected(null)
  }

  const handleOtherAccDelete = async (dataIndex) => {
    try {
      const res = await accountDelete(
        `${accountSelector('otherBankAccount')}/${dataIndex}`
      )
      addAlert({ message: 'Eliminando cuenta...', status: 'loading' })
      if (res) {
        addAlert({ message: 'Cuenta eliminada.', status: 'success' })
        dispatch(
          fetchDealers(
            [''],
            [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
          )
        )
        setModal(false)
      }
    } catch (error) {
      addAlert({ message: 'Error', status: 'error' })
    }
    setSelected(null)
  }

  const handleNationalAccDelete = async (dataIndex) => {
    console.log(`${accountSelector('national')}/${dataIndex}`)
    try {
      const res = await accountDelete(
        `${accountSelector('national')}/${dataIndex}`
      )
      addAlert({ message: 'Eliminando cuenta...', status: 'loading' })
      if (res) {
        addAlert({ message: 'Cuenta eliminada.', status: 'success' })
        dispatch(
          fetchDealers(
            [''],
            [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
          )
        )
        setModal(false)
      }
    } catch (error) {
      addAlert({ message: 'Error', status: 'error' })
    }
    setSelected(null)
  }

  return (
    <div>
      {dealer.accounts.national.length === 0 &&
      dealer.accounts.instantPayment.length === 0 &&
      dealer.accounts.other.length === 0 ? (
        <Empty
          animationProps={{
            height: 200,
            width: 200,
            animation: EmptyAccoutnAnimation,
          }}
          lottieProps={{ style: { position: 'relative', zIndex: 1 } }}
        >
          <p className="font-semibold max-w-xs text-center relative-top-5 z-10 text-sm text-coolGray-500">
            No tienes cuentas agregadas, haz click en agregar cuenta si deseas
            agregar una nueva.
          </p>
        </Empty>
      ) : null}

      {dealer.accounts.national.length !== 0 ? (
        <Accordion
          title={'Cuentas Nacionales'}
          data={nationalAccountMap(dealer.accounts.national)}
          accounts={dealer?.accounts?.national}
          deleteHandler={handleNationalAccDelete}
          enableDelete={enableDelete}
          addToBillsToPay={addToBillsToPay}
        />
      ) : null}

      {dealer.accounts.instantPayment.length !== 0 ? (
        <Accordion
          title={'Pago movil'}
          data={instantPaymentAccountMap(dealer.accounts.instantPayment)}
          accounts={dealer?.accounts?.instantPayment}
          deleteHandler={handleInstantPaymentAccDelete}
          enableDelete={enableDelete}
          addToBillsToPay={addToBillsToPay}
        />
      ) : null}

      {dealer.accounts.other.length !== 0 ? (
        <Accordion
          title={'Otros'}
          data={otherPaymentMap(dealer.accounts?.other)}
          accounts={dealer?.accounts?.other}
          deleteHandler={handleOtherAccDelete}
          enableDelete={enableDelete}
          addToBillsToPay={addToBillsToPay}
        />
      ) : null}
    </div>
  )
}

export const AddAccounts: React.FC<any> = ({
  dealer,
  setModal,
  onCancel,
  setSelected,
  onCreated,
  getAccounts
}) => {
  const form = useForm({})
  console.log("DEAL", dealer)
  const [loading, setLoading] = useState(false)
  const { addAlert } = useSnackBars()
  const banks = useSelector((state: RootState) => state.bank.banks)
  const server = process.env.REACT_APP_SERVER_URL

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchBanks())
  }, [dispatch])

  const [userConfig] = useLocalStorageState('user-config')

  const [, setTypeDocumentSelected] = useState<{
    value: number | string
    text: string
  }>({
    value: 'V',
    text: 'V',
  })

  const [accountType, setAccountType] = useState({
    value: 'national',
    text: 'Banco Nacional',
  })

  const options: OptionsType[] = [
    { value: 'national', text: 'Banco Nacional' },
    { value: 'instantPayment', text: 'Pago Móvil' },
    { value: 'otherBankAccount', text: 'Otros' },
  ]

  const bankType = [
    {
      value: 'Ahorro',
      text: 'Ahorro',
    },
    {
      value: 'Corriente',
      text: 'Corriente',
    },
  ]

  const onSubmit = async (values) => {
    console.log('dealer...', dealer)
    console.log('Valuess..', values)
    // const newValues = {
    //   account: { ...values, provider: { id: dealer.id } },
    // }
    // delete newValues.account.type

    setLoading(true)

    // const url = accountSelector(accountType.value)
    try {
      addAlert({ message: 'Creando cuenta...', status: 'loading' })
      /**
       * values.type = national || instantPayment || otherBankAccount
       */

      let transform = {
        national: 'BANK_ACCOUNT',
        instantPayment: 'INSTANT_PAYMENT',
        otherBankAccount: 'OTHER_ACCOUNT',
      }

      let response = await axios.post(
        `${server}/thirdparty/provider-account`,
        {
          idProvider: dealer.id,
          ...values,
          moneyAccountType: transform[values.type]
        }
      )

      await getAccounts(dealer)

      addAlert({ message: 'Cuenta creada satisfactoriamente', status: 'success' })
      // onCreated(response.data.account)
      // const res = await accountPOST(newValues, url)
      // if (res) {
      //   addAlert({ message: 'Cuenta creada exitosamente', status: 'success' })
      //   dispatch(
      //     fetchDealers(
      //       [''],
      //       [`pageNumber=1`, `pageSize=${userConfig.rowsPerPage}`]
      //     )
      //   )
      // }
    } catch (error) {
      console.log("ERROR", error)
      addAlert({ message: 'Error', status: 'error' })
    } finally {
      setLoading(false)
      setModal(false)
      // setSelected(null)
    }
  }

  return (
    <Form
      form={form}
      onSubmit={(values) => onSubmit(values)}
      classes={`gap-x-6 gap-y-2`}
      style={{ width: '100%' }}
    >
      <FormItem
        name="type"
        rules={{ required: 'Es necesario el campo' }}
        defaultValue={options[0]}
        classes="xl:col-span-4 col-span-12"
      >
        <Select
          options={options}
          label="Modalidad de Pago"
          setSelectedHelper={setAccountType}
        />
      </FormItem>

      {accountType.value === 'instantPayment' ? (
        <>
          <FormItem
            name="bank"
            classes="xl:col-span-8 col-span-12"
            defaultValue={{
              value: banks[0]?.name,
              text: banks[0]?.name,
            }}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.name,
                text: bank.name,
              }))}
              label="Banco"
              setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            defaultValue={docs[0]}
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
          >
            <Select
              options={docs}
              label="Tipo"
              setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            name="document.document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="name"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={100} />
          </FormItem>

          <FormItem
            name="phone"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Campo de tipo númerico' },
            }}
          >
            <InputText phone={true} small label="Teléfono" maxLength={15} />
          </FormItem>

          <FormItem
            name="email"
            classes="xl:col-span-8 col-span-12"
            rules={{
              pattern: {
                value: emailRegex,
                message: 'El email ingresado debe ser válido',
              },
            }}
          >
            <InputText
              small
              isUpperValue={false}
              label="Correo Electrónico"
              maxLength={100}
            />
          </FormItem>
        </>
      ) : null}

      {accountType.value === 'otherBankAccount' ? (
        <>
          <FormItem
            name="name"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-4 col-span-12"
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          <FormItem
            name="paymentMethod"
            classes="xl:col-span-4 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <InputText small label="Método de Pago" maxLength={255} />
          </FormItem>

          <FormItem
            name="description"
            classes="col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <TextArea
              label="Descripción"
              placeholder="Ingresar datos de la cuenta"
              maxLength={255}
            />
          </FormItem>
        </>
      ) : null}

      {accountType.value === 'national' ? (
        <>
          <FormItem
            name="bank"
            classes="xl:col-span-8 col-span-12"
            defaultValue={{
              value: banks[0]?.name,
              text: banks[0]?.name,
            }}
          >
            <Select
              options={banks.map((bank) => ({
                value: bank.name,
                text: bank.name,
              }))}
              label="Banco"
              setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            defaultValue={docs[0]}
            name="document.documentType"
            rules={{ required: 'Es necesario el campo' }}
            classes="xl:col-span-2 col-span-4"
          >
            <Select
              options={docs}
              label="Tipo"
              setSelectedHelper={setTypeDocumentSelected}
            />
          </FormItem>

          <FormItem
            name="document.document"
            classes="xl:col-span-4 col-span-8"
            rules={{
              required: 'Es necesario el documento',
              pattern: { value: /^\d+$/, message: 'Documento inválido' },
              minLength: {
                value: 6,
                message: 'El documento debe de poseer al menos 6 caracteres.',
              },
            }}
          >
            <InputText label="Documento" maxLength={10} />
          </FormItem>

          <FormItem
            name="name"
            classes="xl:col-span-6 col-span-12"
            rules={{ required: 'El campo nombre es requerido' }}
          >
            <InputText small label="Nombre Titular" maxLength={255} />
          </FormItem>

          <FormItem
            name="accountNumber"
            classes="xl:col-span-4 col-span-12"
            rules={{
              required: 'Es necesaria un número de cuenta',
              minLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
              maxLength: {
                value: 20,
                message: 'El número de cuenta debe poseer 20 dígitos',
              },
            }}
          >
            <InputText
              small
              phone={true}
              label="Número de cuenta"
              maxLength={20}
            />
          </FormItem>

          <FormItem
            defaultValue={bankType[0]}
            name="bankAccountType"
            classes="xl:col-span-3 col-span-12"
            rules={{ required: 'Es necesario el campo' }}
          >
            <Select options={bankType} label="Tipo de cuenta" />
          </FormItem>

          <FormItem
            name="email"
            classes="xl:col-span-5 col-span-12"
            rules={{
              pattern: {
                value: emailRegex,
                message: 'El email ingresado debe ser válido',
              },
            }}
          >
            <InputText
              isUpperValue={false}
              small
              label="Correo Electrónico"
              maxLength={255}
            />
          </FormItem>
        </>
      ) : null}

      <div className="col-span-12 h-full flex flex-row mt-5">
        <div className="w-1/2 mr-5 pl-1">
          <Button
            onClick={() => {
              onCancel()
              console.log('cancel')
            }}
            type="outline"
            classes="w-full"
          >
            Cancelar
          </Button>
        </div>
        <div className="w-1/2 pr-1">
          <Button type="primary" classes="w-full" htmlType="submit">
            Añadir
          </Button>
        </div>
      </div>
    </Form>
  )
}

interface OptionsType {
  value: string
  text: string
}
